import React, { useMemo } from 'react';
import { TimeSeriesLineChart } from '@/components/visuals';
import type { ChartDensity } from '@/components/visuals';

export interface MilestoneOnTimeChartProps {
  xAxisData: string[];
  onTimePct: number[];
  height?: number | string;
  showDataLabels: boolean;
  density?: ChartDensity;
}

export function MilestoneOnTimeChart({
  xAxisData,
  onTimePct,
  height = 260,
  showDataLabels = false,
  density = 'overview',
}: MilestoneOnTimeChartProps) {
  const series = useMemo(
    () => [{ name: 'On-time %', data: onTimePct }],
    [onTimePct]
  );
  return (
    <TimeSeriesLineChart
      xAxisData={xAxisData}
      series={series}
      height={height}
      showDataLabels={showDataLabels}
      density={density}
    />
  );
}
